import { confirmedCancellationNoShow } from "../../utils/realTimeUtils"

export default function PatientNurseStats({ patientSchedule, nurseSchedule }) {
	const activePatients = patientSchedule.filter(patient => !confirmedCancellationNoShow(patient))
	const totalPatients = activePatients.length

	return (
		<div className="flex items-center gap-4">
			<div className="flex flex-col mr-2">
				<span className="text-gray-800 text-lg">
					<span className="font-bold">Total Patients: {totalPatients}</span>{" "}
					<span className="text-sm">/</span> {patientSchedule.length}
				</span>
			</div>
			<span className="text-gray-800 text-lg">
				Acuity Mix:{" "}
				{Object.entries(
					activePatients.reduce((acc, patient) => {
						acc[patient.acuity] = (acc[patient.acuity] || 0) + 1
						return acc
					}, {})
				)
					.map(
						([acuity, count], i, arr) =>
							`${acuity}: ${count}${i < arr.length - 1 ? " • " : ""}`
					)
					.join("")}
			</span>
			<span className="text-gray-800 font-bold text-lg">
				Total Nurses: {nurseSchedule.length} (
				{Object.entries(
					nurseSchedule.reduce((acc, nurse) => {
						acc[nurse.nurseRole] = (acc[nurse.nurseRole] || 0) + 1
						return acc
					}, {})
				)
					.map(
						([role, count], i, arr) =>
							`${count} ${role}${i < arr.length - 1 ? " • " : ""}`
					)
					.join("")}
				)
			</span>
		</div>
	)
}
